import * as React from "react";
import { IconProps } from "./IconProps";

export const IconShoppingCart = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.833008 3.33333C0.833008 2.8731 1.2061 2.5 1.66634 2.5H4.16634C4.57371 2.5 4.92137 2.79451 4.98834 3.19633L5.28895 5H16.6663C16.9113 5 17.1439 5.10778 17.3022 5.29469C17.4605 5.4816 17.5286 5.72871 17.4883 5.97033L16.2383 13.4703C16.1714 13.8722 15.8237 14.1667 15.4163 14.1667H5.83301C5.42564 14.1667 5.07798 13.8722 5.01101 13.4703L3.4604 4.16667H1.66634C1.2061 4.16667 0.833008 3.79357 0.833008 3.33333ZM5.56673 6.66667L6.53895 12.5H14.7104L15.6826 6.66667H5.56673Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12467 16.6667C8.12467 17.357 7.56503 17.9167 6.87467 17.9167C6.18432 17.9167 5.62467 17.357 5.62467 16.6667C5.62467 15.9763 6.18432 15.4167 6.87467 15.4167C7.56503 15.4167 8.12467 15.9763 8.12467 16.6667ZM15.6247 16.6667C15.6247 17.357 15.065 17.9167 14.3747 17.9167C13.6843 17.9167 13.1247 17.357 13.1247 16.6667C13.1247 15.9763 13.6843 15.4167 14.3747 15.4167C15.065 15.4167 15.6247 15.9763 15.6247 16.6667Z"
          fill={color}
        />
      </svg>
    );
  }
);
